import { render, staticRenderFns } from "./xijixianDetails.vue?vue&type=template&id=48a7d554"
import script from "./xijixianDetails.vue?vue&type=script&lang=js"
export * from "./xijixianDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports